export const WelcomeOfferBonusTypeDto = {
    Sport: 'sport',
    Casino: 'casino',
};

export type WelcomeOfferBonusTypeDto = typeof WelcomeOfferBonusTypeDto[keyof typeof WelcomeOfferBonusTypeDto];
